<template>
    <v-container fluid>
        <v-layout row wrap>
            <v-flex class="text-xs-center" mt-5 xs12>
                <h1 @click="test">Home page</h1>
            </v-flex>
        </v-layout>
<!--        <v-job-model-dialog ref="test-dialog"/>-->
    </v-container>
</template>

<script>
    import ViewRules from "../utils/ViewRules";
    //import VJobModelDialog from "../app/jobs/VJobModelDialog";

    export default {
        //components: {VJobModelDialog},
        data: () => ({
            items: []
        }),
        computed: {},
        methods: {
            test() {
                this.$refs['test-dialog'].show(ViewRules.UPDATE, null)
                    .then((data) => {
                        console.log(data);
                    }).catch(() => {
                });
            }
        },
        created() {
        }
    };
</script>